import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Analytics = Loadable(lazy(() => import('./ChangePasswordSection')));

const ChangePasswordRoutes = [
	{ path: '/dashboard/changepassword', element: <Analytics />, auth: authRoles.admin },
];

export default ChangePasswordRoutes;
